import React from "react";

const listIcon = ({ width = "20", height = "20", fill = "#1C274C", className = "" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M10 11L3 11" stroke={fill} strokeWidth="1.5" strokeLinecap="round" />
      <path d="M10 16H3" stroke={fill} strokeWidth="1.5" strokeLinecap="round" />
      <path
        d="M14 13.5L16.1 16L20 11"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 6L13.5 6M20 6L17.75 6"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default listIcon;
